export const PROJECT_ADMIN_ROLE = 'project_admin';
export const EDITOR_ROLES = ['school_admin', 'professional'];
export const SCHOOL_MANAGER_ROLES = ['project_admin', 'school_admin'];
export const PARENT_ROLE = 'parent';

export const STAFF_TABS = ['resumo', 'estudo', 'avaliacao', 'atividades', 'atendimento', 'evolucao', 'pei', 'relatorio'];
export const PARENT_TABS = ['resumo', 'evolucao', 'relatorio'];

export function roleOf(userOrRole) {
  return typeof userOrRole === 'string' ? userOrRole : userOrRole?.role;
}

export function isProjectAdmin(userOrRole) {
  return roleOf(userOrRole) === PROJECT_ADMIN_ROLE;
}

export function canEdit(userOrRole) {
  return EDITOR_ROLES.includes(roleOf(userOrRole));
}

export function canManageSchool(userOrRole) {
  return SCHOOL_MANAGER_ROLES.includes(roleOf(userOrRole));
}

export function canImportStudentData(userOrRole) {
  return canManageSchool(userOrRole);
}

export function canAccessBackup(userOrRole) {
  return canImportStudentData(userOrRole);
}

export function tabsForRole(userOrRole) {
  const role = roleOf(userOrRole);
  if (role === PARENT_ROLE) return PARENT_TABS;
  return STAFF_TABS;
}

export function safeTabForRole(tab, userOrRole) {
  const tabs = tabsForRole(userOrRole);
  return tabs.includes(tab) ? tab : tabs[0];
}
